import { Box, Button, Dialog, Typography } from '@mui/material';
import React from 'react';
import { useMainContext } from './Layout';
import AlertTriangle from 'components/Icons/AlertTriangle';

const ModalWarningClearVerify = ({
  onClickPlots,
  open,
  onClose,
  onClick,
  title = 'Exiting verification?',
  description = 'Are you sure you want to exit the verification? This will clear the certificate verification process on the current plot.',
}) => {
  const { warningVerify, setWarningVerify } = useMainContext();

  const onClickYes = () => {
    if (onClickPlots && warningVerify) {
      onClickPlots({ plots: warningVerify }, false);
    }
    onClick && onClick();
    onClose && onClose();
    setWarningVerify(null);
  };

  const onClickNo = () => {
    setWarningVerify(null);
    onClose && onClose();
  };

  return (
    <Dialog
      open={open || Boolean(warningVerify)}
      onClose={() => {
        setWarningVerify(null);
        onClose && onClose();
      }}
    >
      <Box p={4}>
        <Box
          bgcolor={'danger.110'}
          width={'fit-content'}
          borderRadius={'12px'}
          p={1}
        >
          <AlertTriangle />
        </Box>
        <Typography fontWeight={700} fontSize={21} my={2}>
          {title}
        </Typography>
        <Typography mb={2}>{description}</Typography>
        <Box display={'flex'} gap={2} justifyContent={'flex-end'}>
          <Button
            sx={{
              color: 'black',
              border: '1px solid rgba(0, 0, 0, 0.3)',
              '&:hover': {
                border: '1px solid rgba(0, 0, 0, 0.7)',
              },
            }}
            variant="outlined"
            onClick={onClickNo}
          >
            Cancel
          </Button>
          <Button
            sx={{
              color: 'white',
            }}
            color="danger"
            variant="contained"
            onClick={onClickYes}
          >
            Agree
          </Button>
        </Box>
      </Box>
    </Dialog>
  );
};

export default ModalWarningClearVerify;
